import Image from 'next/image';
import { ItemData } from '@core/types/cloudmatrix.types';
import { VideoCardProps } from '@components/v3/molecules/video-cards';
import { generateFullPathname } from '@utils/paths/generateFullPathname.utils';
import { Locale } from '@core/constants/locales.constants';
import templateConfig from '@templateConfig';
import { Lock } from '@components/icons';
import { Translations } from '@lib/dictionary-keys/__generated__';

export type VideoCardSettings = {
  dictionary: {
    membersOnly: Translations['videoCard']['label']['membersOnly'];
  };
};

const streamVideoCardTransform = (
  { mediaData, metaData, publicationData }: ItemData,
  locale: Locale,
  { dictionary }: VideoCardSettings
): VideoCardProps => {
  const leftoverSeconds = metaData.VideoDuration % 60;
  const withEntitlements = metaData?.SysEntryEntitlements.length > 0;
  const isFreemium =
    withEntitlements && metaData?.SysEntryEntitlements.includes('freemium');

  return {
    type: 'default',
    slug: generateFullPathname({
      locale,
      route: templateConfig.navigation.routes.VIDEO_DETAIL,
      params: {
        slug: mediaData.entryId,
      },
      query: {
        provider: 'stream',
      },
    }),
    membersBadge: withEntitlements
      ? {
          text: isFreemium ? '' : dictionary.membersOnly,
          leftElement: <Lock />,
        }
      : undefined,
    image: (
      <Image
        src={`${mediaData.thumbnailUrl}width/600`}
        alt={mediaData.entryId}
        width={0}
        height={0}
        sizes="100vw"
        style={{ width: '100%', height: 'auto' }} // optional
      />
    ),
    category: metaData.category && {
      category: metaData.category,
      slug: '',
    },
    publishDate: {
      date: new Date(publicationData.createdAt),
      format: "DD MMM 'YY",
      locale,
      onDark: true,
    },
    title: metaData.title,
    duration: metaData.VideoDuration && {
      icon: null,
      text: `${Math.floor(metaData.VideoDuration / 60)}:${leftoverSeconds < 10 ? '0' : ''}${leftoverSeconds}`,
    },
    onDark: true,
  };
};

export default streamVideoCardTransform;
